var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"card"}},[(_vm.title)?_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default"),(_vm.info)?_c('div',{staticClass:"informacao"},[(_vm.info)?_c('i',{staticClass:"information-card mdi mdi-information-outline"}):_vm._e(),_c('h5',[_c('em',[_vm._v(_vm._s(_vm.info))])])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }